module.exports = __webpack_public_path__ + "static/img/1.00d5c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-construccion/1.png
// module id = 3ZHL
// module chunks = 0